import { FC } from 'react';
import { StyledModal } from "./styled";
import { Button } from 'elements';

// @ts-ignore
import statmentIcon from "assets/svg/StatmentIconBlue.svg";

import {
  Container,
  Content,
  Image,
  Heading,
  Text,
  ButtonsGroup
} from "./styled";

interface IProps {
  isOpen: boolean;
  onOK: () => void;
  onCancel: () => void;
}

const ExitConfirmModal: FC<IProps> = ({
  isOpen,
  onOK,
  onCancel
}) => {
  return (
    <Container>
      <StyledModal
        bodyStyle={{
          padding: 0,
        }}
        open={isOpen}
        width={616}
        centered
        footer={null}
        maskClosable={false}
        onCancel={onCancel}
      >
        <Content>
          <Image src={statmentIcon} />

          <Heading>Cancel changes?</Heading>
          <Text>Your edits won’t be saved.</Text>

          <ButtonsGroup>
            <Button styleType="secondary" onClick={onCancel}>Return to Editing</Button>
            <Button styleType="primary" onClick={onOK}>Continue Without Saving</Button>
          </ButtonsGroup>
        </Content>
      </StyledModal>
    </Container>
  );
};

export default ExitConfirmModal;
